import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Equipes from "@/pages/Equipes";
import Transferts from "@/pages/Transferts";
import Finances from "@/pages/Finances";
import RH from "@/pages/RH";
import Membres from "@/pages/Membres";
import Documents from "@/pages/Documents";
import Utilisateurs from "@/pages/Utilisateurs";
import Calendrier from "@/pages/Calendrier";
import Budget from "@/pages/Budget";
import Portail from "@/pages/Portail";
import Communication from "@/pages/Communication";
import Classements from "@/pages/Classements";
import PlayerReport from "@/pages/PlayerReport";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "joueur" || user.role === "parent") return <Navigate to="/portail" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route path="/portail" element={
              <ProtectedRoute allowPortail><Portail /></ProtectedRoute>
            } />
            <Route path="/portail/bilan/:id" element={
              <ProtectedRoute allowPortail><PlayerReport /></ProtectedRoute>
            } />

            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/equipes" element={<Equipes />} />
              <Route path="/joueurs/:id/bilan" element={<PlayerReport />} />
              <Route path="/calendrier" element={<Calendrier />} />
              <Route path="/classements" element={<Classements />} />
              <Route path="/communication" element={<Communication />} />
              <Route path="/transferts" element={<Transferts />} />
              <Route path="/finances" element={<Finances />} />
              <Route path="/budget" element={<Budget />} />
              <Route path="/rh" element={<RH />} />
              <Route path="/membres" element={<Membres />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/utilisateurs" element={<Utilisateurs />} />
            </Route>

            <Route path="/" element={<RootRedirect />} />
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
